<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 96 960 960"
    width="24"
    fill="currentColor"
  >
    <path
      d="M320 816H160q-17 0-28.5-11.5T120 776q0-17 11.5-28.5T160 736h160q17 0 28.5 11.5T360 776q0 17-11.5 28.5T320 816Zm480-400H160q-17 0-28.5-11.5T120 376q0-17 11.5-28.5T160 336h640q17 0 28.5 11.5T840 376q0 17-11.5 28.5T800 416ZM560 616H160q-17 0-28.5-11.5T120 576q0-17 11.5-28.5T160 536h400q17 0 28.5 11.5T600 576q0 17-11.5 28.5T560 616Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Sort'
  }
</script>
